import {
  localStorageSetWithExpiry,
  localStorageGetWithExpiry,
} from './storages/localStorage';
import axios from 'axios';

const TOKEN = 'token';
const REFRESH_TOKEN = 'refresh_token';

export const setAccessToken = (token: string, expiresIn: number) => {
  return localStorageSetWithExpiry(
    TOKEN,
    token,
    new Date((expiresIn || 1800) * 1000 + Date.now()).getTime()
  );
};

export const setRefreshToken = (token: string, expiresIn: number) => {
  return localStorageSetWithExpiry(
    REFRESH_TOKEN,
    token,
    new Date((expiresIn || 86400) * 1000 + Date.now()).getTime()
  );
};

export const getAccessToken = () => localStorageGetWithExpiry(TOKEN);
export const getRefreshToken = () => localStorageGetWithExpiry(REFRESH_TOKEN);

export const fetchTokenFromPassword = ({
  username = '',
  password = '',
  authUrl,
  clientId,
}) => {
  let requestBody = new URLSearchParams();

  requestBody.append('grant_type', 'password');
  requestBody.append('client_id', clientId);
  requestBody.append('username', username);
  requestBody.append('password', password);
  // requestBody.append('redirect_uri', window.location.origin);

  return axios({
    method: 'post',
    url: authUrl,
    data: requestBody,
  });
};
